module.exports = __webpack_public_path__ + "forbidden_planet.7c5838fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/cinema/forbidden_planet.jpg
// module id = a+Te
// module chunks = 0